<template>
    <div class="row">
        <div class="col-12">
            <div class="chart">
                <div class="d-flex justify-content-between p-3">
                    <h1>Кассирами</h1>
                    <select name="" id="" v-model="type" class="custom-select w-50">
                        <option value="weekly">Неделя</option>
                        <option value="monthly">Месяц</option>
                        <option value="annual">Год</option>
                    </select>
                </div>
                <p class="justify-content-between pl-3">{{ cashierFromDate + ' - ' + cashierToDate }}</p>
                <apexchart ref="barChart" height="350" type="bar" :options="options" :series="series"></apexchart>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CashiersDashboard",
        data() {
            return {
                type: 'weekly',
                options: {
                    chart: {
                        height: 350,
                        type: 'bar',
                        stacked: true,
                        toolbar: {
                            show: true
                        },
                        zoom: {
                            enabled: true
                        }
                    },
                    responsive: [{
                        breakpoint: 480,
                        options: {
                            legend: {
                                position: 'top',
                                offsetX: 10,
                                offsetY: 0
                            }
                        }
                    }],
                    plotOptions: {
                        bar: {
                            horizontal: false,
                            columnWidth: '40%',
                            endingShape: 'flat',
                            dataLabels: {
                                position: 'top', // top, center, bottom
                                style: {
                                    color: '#000'
                                }
                            },
                        },
                    },
                    xaxis: {
                        type: 'category',
                        categories: [],
                    },
                    legend: {
                        position: 'right',
                        offsetY: 40
                    },
                    fill: {
                        opacity: 1
                    },
                    dataLabels: {
                        enabled: true,
                        formatter: function (val) {
                            return val.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
                        },
                        offsetY: -20,
                        style: {
                            fontSize: '12px',
                            colors: ["#304758"]
                        }
                    }
                },
                series: [
                    {
                        name: 'Продажа',
                        data: []
                    },
                    {
                        name: 'Возврат',
                        data: []
                    }
                ],
				cashierFromDate: '',
				cashierToDate: ''
            }
        },
        created() {
            this.init();
        },
        methods: {
            init() {
                let data = {};
                data[this.type] = true;
                this.$api.get('dashboard.cashiers-report', data)
                    .then(res => {
                        let data = res.data.data;
						this.cashierFromDate = this.$moment(res.data.range.from.date).format('Y-MM-DD');
						this.cashierToDate = this.$moment(res.data.range.to.date).format('Y-MM-DD');
                        let categories = [];
                        let series_one = [];
                        let series_two = [];
                        data.forEach(item => {
                            categories.push(item.name);
                            series_one.push(item.all_amount);
                            series_two.push(item.reverted_amount);
                        });
                        let options = this.options;
                        options.xaxis.categories = categories;
                        this.$refs.barChart.updateOptions(options);

                        let series = this.series;
                        series[0].data = series_one;
                        series[1].data = series_two;
                        this.$refs.barChart.updateSeries(series);
                    })
            }
        },
        watch: {
            type: function () {
                this.init();
            }
        }
    }
</script>

<style scoped>

</style>
